import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateRegion } from "common/services/regions.service";
import CountryForm from "./CountryForm";
import { toast } from "react-toastify";
import { COUNTRY_LEVEL } from "common/constants";

const UpdateCountry: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: selectedRecord?.name,
      altName1: selectedRecord?.altName1,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      altName1: Yup.string(),
    }),
    onSubmit: async (values: any) => {
      const data = {
        id: selectedRecord?.id,
        data: {
          name: values["name"] ? values["name"].trim() : null,
          altName1: values["altName1"] ? values["altName1"].trim() : null,
          level: COUNTRY_LEVEL,
        },
      };

      setLoading(true);
      try {
        await updateRegion(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Country updated successfully", {});
      } catch (e: any) {
        toast.error("Failed to update country", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Country
      </ModalHeader>

      <CountryForm
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
        setLoading={setLoading}
      />
    </Modal>
  );
};

export default UpdateCountry;
